<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Statistic Type
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        v-bind:options.sync="pagination"
        item-key="name"
        :loading="loading"
        :no-data-text="noDataText"
        :custom-filter="customSearch"
      >
        <template v-slot:item="row"
          ><tr>
            <td class="text-xs-left">{{ row.item.statsType }}</td>
            <td class="text-xs-left">{{ row.item.statsTypeDesc }}</td>
            <td class="table-action-header">
              <table-action
                :rowData="row"
                review
                @review="doReview(row.item.statsType)"
                query
                @query="doQuery(row.item.statsType)"
                remove
                @remove="doDelete(row.item.statsType)"
              ></table-action>
            </td></tr
        ></template>
      </v-data-table>
      <confirm ref="confirmDelete">
        Are you sure you want to delete the selected Statistics Type and its related Statistics Value? ({{ selectedStatsType }})
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [{ text: 'Statistic Type', value: 'statsType' }, { text: 'Description', value: 'statsTypeDesc' }, TableConst.tableActionHeader],
      selectedStatsType: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      const apiURI = this.menu.statsTypeList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((statsType) => {
                const convertList = {
                  statsType: statsType.statsType,
                  statsTypeDesc: statsType.statsTypeDesc
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doNew() {
      this.$router.push({
        name: 'statsTypeDet',
        params: {
          statsType: 'new',
          modeStatsType: 'New'
        }
      })
    },
    doReview(statsType) {
      this.$router.push({
        name: 'statsTypeDet',
        params: {
          statsType,
          modeStatsType: 'Review'
        }
      })
    },
    doQuery(statsType) {
      this.$router.push({
        name: 'statsTypeDet',
        params: {
          statsType,
          modeStatsType: 'Query'
        }
      })
    },
    async doDelete(statsType) {
      this.resetMessages()
      if (statsType) {
        const expand = {
          statsType
        }
        const apiURI = this.menu.checkDeleteStatsType
        const apiURI2 = this.menu.deleteStatsType
        if (apiURI && apiURI2) {
          try {
            await this.$http.get(expandURI(apiURI, expand))
            this.selectedStatsType = statsType
            const prompt = await this.$refs.confirmDelete.doPopUp()
            if (prompt) {
              const result = await this.$http.delete(expandURI(apiURI2, expand))
              const { data } = result
              this.notify(data)
              this.doInit()
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.statsTypeParam.menu
    }
    // filteredItems() {
    //   return this.items.filter((item) => {
    //     return !this.search || (item.fund.toLowerCase().includes(this.search.toLowerCase()))
    //   })
    // }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
